import { createFileRoute } from "@tanstack/react-router"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { ChargeProvider } from "@/stores/charge-store"
import CardChargeBuy from "@/components/card-charge-buy"
import CardChargeList from "@/components/card-charge-list"

export const Route = createFileRoute("/card-charge/")({
  component: CardChargeRoute,
})



function CardChargeRoute() {
  

  return (
    <ChargeProvider>
      <Tabs defaultValue="buy">
        <TabsList className="sticky top-10 inset-x-0">
        <TabsTrigger value="buy">خرید کارت شارژ</TabsTrigger>
        <TabsTrigger value="list">کارت شارژ های خریداری شده</TabsTrigger>
        </TabsList>

        <TabsContent value="buy">
          <CardChargeBuy />
        </TabsContent>
        <TabsContent value="list">
        <CardChargeList />
        </TabsContent>
      </Tabs>

      
    </ChargeProvider>
  )
}
